import React from 'react'

import styled from 'styled-components'

import { useCompanyCopies } from 'core/hooks'
import variables from 'core/styles/variables'

const Consents = styled.div`
  color: ${variables.colorBlack70};
`

const Content = styled.div`
  width: 100%;
  color: ${variables.colorBlack70};
  white-space: pre-wrap;

  a {
    color: ${variables.colorBluePrimary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`

const FooterConsents = () => {
  const { consent } = useCompanyCopies()

  const consentHtml = { __html: consent }

  return <Consents>{consent && <Content dangerouslySetInnerHTML={consentHtml} />}</Consents>
}

export default FooterConsents
